import type { QueryKey } from '@tanstack/react-query';
import { useQuery } from '../../../ReactQuery';
import type { GetActiveBannersResponse } from '../../../../typings/api';
import { get } from '../../../redux/api';

//  Banners aren't updated often, so we can cache them for a while.
const ACTIVE_BANNERS_STALE_TIME = 1000 * 60 * 5; // 5 minutes

//  Fetch the banners from the API
function getActiveBanners() {
  return get<GetActiveBannersResponse>('/api/banners/active');
}

export const getActiveBannersQueryKey: QueryKey = ['banners', 'active'];

/**
 * Hook for fetching active banners.
 */
export default function useActiveBanners() {
  return useQuery<GetActiveBannersResponse>({
    queryFn: getActiveBanners,
    queryKey: getActiveBannersQueryKey,
    staleTime: ACTIVE_BANNERS_STALE_TIME,
  });
}
